import { useMutation } from "react-query";
import { useRecoilValue } from "recoil";

import { loginState } from "../../stores/loginState";
import { LogenInstance, LotteInstance } from "../instance";

// 수동 등록 파일 히스토리 조회 API
export const useGetManualScanFileHistory = () => {
  const login = useRecoilValue(loginState);

  const mutation = useMutation((branCd) => {
    if (!branCd) {
      return Promise.resolve({ result: "00", data: [] });
    }

    const instance = login.company === "LOGEN" ? LogenInstance : LotteInstance;

    return instance.get(`/manual-scan-files/history/${encodeURIComponent(branCd)}`).then((response) => response.data);
  });

  return mutation;
};
